/**
 * Stabilizer builder — horizontal stabilizer + vertical stabilizer (fin).
 * Supports conventional and T-tail configurations.
 */

import * as THREE from 'three'
import type { CategoryProfile } from '../types'

export function createStabilizers(
  hStabSpan: number,
  hStabChord: number,
  vStabHeight: number,
  fuselageRadius: number,
  tailZ: number,
  profile: CategoryProfile,
  material: THREE.MeshStandardMaterial
): THREE.Group {
  const group = new THREE.Group()
  group.name = 'stabilizers'

  const hStabThickness = hStabChord * 0.10
  const vStabThickness = hStabChord * 0.08
  const vStabChord = hStabChord * 1.2

  // Vertical stabilizer (fin)
  const vStabGeo = new THREE.BoxGeometry(vStabThickness, vStabHeight, vStabChord)
  const vStab = new THREE.Mesh(vStabGeo, material)
  vStab.position.set(0, fuselageRadius + vStabHeight / 2, tailZ)
  vStab.castShadow = true
  group.add(vStab)

  // Horizontal stabilizer
  const hStabGeo = new THREE.BoxGeometry(hStabSpan, hStabThickness, hStabChord)
  const hStab = new THREE.Mesh(hStabGeo, material)

  if (profile.tailType === 't-tail') {
    // T-tail: h-stab sits at top of v-stab
    hStab.position.set(0, fuselageRadius + vStabHeight, tailZ)
  } else {
    // Conventional: h-stab at fuselage centerline height
    hStab.position.set(0, fuselageRadius * 0.8, tailZ)
  }

  hStab.castShadow = true
  group.add(hStab)

  return group
}
